<template>
  <v-container>
    <v-form>
      <v-card>
        <v-container>
          <v-card-title class="title-highlight">
            {{ $t('title.admin-report-confirm-download') }}
          </v-card-title>

          <v-layout row wrap class="rowBox">
            <v-flex xs12 sm5>
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="startDate"
                    label="開始日"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="startDate"
                  @input="menu = false"
                  locale="jp-ja"
                  :day-format="startDate => new Date(startDate).getDate()"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <!-- 여백 추가 -->
            <v-flex xs12 sm1></v-flex>

            <v-flex xs12 sm5>
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="endDate"
                    label="終了日"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="endDate"
                  @input="menu2 = false"
                  locale="jp-ja"
                  :day-format="endDate => new Date(endDate).getDate()"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>

          <div class="caption grey--text text--darken-1 text-xs-left mt-1">
            ※選択できる期間は最大1年です。
          </div>

          <v-select
              v-model="selectedBrandForDownload"
              :items="brands"
              label="ブランド選択"
              item-text="brandName"
              item-value="brandId"
              clearable              
            ></v-select>

          <!-- <v-select
            v-model="selectedSupplierForDownload"
            :items="suppliers"
            label="取引先選択"
            item-text="supplierName"
            item-value="supplierCode"
            clearable
          ></v-select> -->
          <v-flex xs12>
            <v-btn block color="success" dark 
              @click="downloadCsv()" 
              :loading="downloadLoading"
              :disabled="downloadLoading"
            >
              <v-icon dark left>get_app</v-icon>{{ $t('download-btn') }}
            </v-btn>
          </v-flex>
        </v-container>
      </v-card>
      <br />
      <v-card>
        <v-container>
          <v-card-title class="title-highlight">
            売上報告確認
          </v-card-title>
          <v-layout row wrap align-center>
            <v-flex xs12 sm5>
              <v-menu
                v-model="menu3"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="salesReportDate"
                    label="売上日"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="reportDatePicker"
                  @input="menu3 = false"
                  locale="jp-ja"
                  :day-format="reportDate => new Date(reportDate).getDate()"
                  no-title
                  :events="functionEvents"
                  event-color="green lighten-1"
                  @change="changeSalesReportDate()"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <!-- 여백 추가 -->
            <v-flex xs12 sm1></v-flex>

            <v-flex xs12 sm5>
              <v-select
                v-model="selectedBrand"
                :items="brands"
                label="ブランド選択"
                item-text="brandName"
                item-value="brandId"
                clearable
                return-object
              ></v-select>

              <div class="brand-select-note">
                ※全ブランドを表示するには、「✖」で選択を解除してください
              </div>
            </v-flex>
          </v-layout>

          <!-- 여백 추가 -->
          <v-flex xs12 sm1></v-flex>

          <v-data-table
            :headers="headers"
            :items="filteredStores"
            hide-actions
            class="elevation-1"
          >
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{ props.header.text }}</span>
                </template>
                <span>{{ props.header.text }}</span>
              </v-tooltip>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-left" @click="forwardReportConfirmDetail(props.item)" >{{ props.item.storeName }}</td>
                <td class="text-xs-center" @click="forwardReportConfirmDetail(props.item)" >{{ props.item.createdUser }}</td>
                <td class="text-xs-center" @click="forwardReportConfirmDetail(props.item)" >{{ props.item.createdAt }}</td>
                <td class="text-xs-left">
                  <v-flex xs3 sm3>
                    <v-btn block color="error" dark v-bind:disabled="!props.item.createdAt" @click="deleteDialog(props.item)">
                      <v-icon dark left>delete_forever</v-icon>{{ $t('delete-btn') }}
                    </v-btn>
                  </v-flex>
                </td>
              </tr>
            </template>
          </v-data-table>

          <div style="height: 15px;"></div>

          <v-layout row reverse>
            <v-flex xs4 sm4>
              <v-text-field
                :value="displayGrandSumTotal"
                box
                label="売上金額合計"
                prepend-inner-icon="mdi-currency-jpy"
                readonly
                style="font-weight:bold !important;"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>

      <!-- 삭제 다이알로그 -->
      <v-dialog max-width="300px" v-model="dispDeleteDialog">
        <v-card>
          <v-container>
            <v-card-title>
              <span style="margin: 0 auto 0;">{{ $t('delete-btn') }}しますか</span>
            </v-card-title>
            <v-layout row wrap style="margin-bottom:20px;">
              <v-flex xs12 sm12>
                <v-btn color="error" text @click="deleteSalesReport()">{{ $t('delete-btn') }}</v-btn>
                <v-btn text @click.stop="dispDeleteDialog = false">{{ $t('back-btn') }}</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-dialog>

      <!-- 売上報告詳細ダイアログ -->
      <v-dialog v-model="dialog" width="700" @keydown.esc="closeDetailDialog()">
        <v-card>
          <v-card-title class="headline grey lighten-2" style="padding: 10px;">売上報告詳細</v-card-title>

          <div style="height: 20px;"></div>
          <v-container>
            <div style="font-size: 20px;">{{ selectedStoreReport.storeName }}</div>

            <v-flex>
              <v-autocomplete
                v-model="workedUsers"
                :items="salesUsers"
                label="販売員"
                item-text="userName"
                item-value="userId"
                chips
                multiple
                deletable-chips
                return-object
                prepend-icon="group"
              ></v-autocomplete>
            </v-flex>

            <v-data-table
              :headers="salesReportConfirmHeader"
              :items="salesReportDetail"
              hide-actions
              class="elevation-1"
              style="width: 100%; margin: 15px 0 0;"
              :no-data-text="$t('noTableDataAvailable')"
            >
              <template v-slot:items="props">
                <tr @click="editDetail(props.item)">
                  <td class="text-xs-left">{{ props.item.itemName }}</td>
                  <td class="text-xs-right">{{ props.item.quantity }}</td>
                  <td class="text-xs-right">{{ props.item.presentQuantity }}</td>
                  <td class="text-xs-right">{{ props.item.unitPrice * props.item.quantity }}</td>
                  <td class="text-xs-right">{{ props.item.referenceStock }}</td>
                </tr>
              </template>
            </v-data-table>
            
            <!-- 追加ボタン -->
            <v-layout row wrap>
              <v-flex xs12 sm12>
                <v-btn class="pa-0 ma-0" block color="info" dark @click="addItem()">
                  <v-icon dark left>add_circle_outline</v-icon>追加
                </v-btn>
              </v-flex>
            </v-layout>

            <div style="height: 35px;"></div>

            <v-layout row reverse>
              <v-flex xs4 sm4>
                <v-text-field
                  v-model="sumTotal"
                  box
                  label="売上金額合計​"
                  prepend-inner-icon="mdi-currency-jpy"
                  readonly
                  style="font-weight:bold !important;"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-flex xs12 sm12>
              <v-textarea outline v-model="remarks" label="日報内容​" ></v-textarea>
            </v-flex>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#4C728A" dark @click="closeDetailDialog()">閉じる</v-btn>
              <v-btn color="#4C728A" dark @click="updateSalesReport()">
                <v-icon dark>save</v-icon>{{ $t('update-btn') }}
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-dialog>

      <v-dialog v-model="addDialog" max-width="500px" @keydown.esc="closeAddItem()">
        <v-card>
          <v-card-title class="headline grey lighten-2 pa-3">売上商品追加</v-card-title>
          <v-container>
            <v-container grid-list-md>
              <v-layout row warp>
                <v-flex grow>
                  <v-autocomplete
                    v-model="addReportItem"
                    :items="storeItems"
                    label="商品"
                    item-text="dispItemName"
                    item-value="itemCode"
                    chips
                    deletable-chips
                    return-object
                    prepend-icon="add_box"
                    @change="onChangeReportItem()"
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
              <v-layout row warp align-content-center>
                <v-flex xs5 sm5>
                  <v-text-field
                    v-model="selectedAddItem.referenceStock"
                    value="0"
                    label="参考在庫"
                    type="number"
                    min="0"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <div style="height: 10px;"></div>
              <v-divider></v-divider>
              <v-layout row wrap justify-space-between align-center>
                <v-flex xs5 sm5>
                  <v-text-field
                    v-model="selectedAddItem.quantity"
                    value="0"
                    label="売上個数"
                    type="number"
                    min="0"
                    @click="selectedAddItem.quantity = ''"
                  ></v-text-field>
                </v-flex>

                <v-flex xs5 sm5>
                  <v-text-field
                    v-model="selectedAddItem.presentQuantity"
                    value="0"
                    label="プレゼント"
                    type="number"
                    min="0"
                    @click="selectedAddItem.presentQuantity = ''"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
            </v-container>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="closeAddItem()">
                <v-icon dark>arrow_back</v-icon>{{ $t('back-btn') }}
              </v-btn>
              <v-btn color="blue darken-1" flat @click="addSalesReportDetail()">
                <v-icon dark>add</v-icon>追加
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-dialog>

      <v-dialog v-model="updateDialog" max-width="500px" @keydown.esc="close()">
        <v-card>
          <v-card-title class="headline grey lighten-2 pa-3">売上修正</v-card-title>
          <v-container>
            <!-- <v-card-text> -->
            <v-container grid-list-md>
              <v-layout row warp>
                <p class="font-weight-bold text-xs-left">商品名: {{ this.editedItem.itemName }}</p>
              </v-layout>
              <v-layout row warp align-content-center>
                <!-- <p class="font-weight-bold">参考在庫: 100</p> -->
                <v-flex xs5 sm5>
                  <v-text-field
                    v-model="editedItem.referenceStock"
                    value="0"
                    label="参考在庫"
                    type="number"
                    min="0"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <div style="height: 10px;"></div>
              <v-divider></v-divider>
              <v-layout row wrap justify-space-between align-center>
                <v-flex xs5 sm5>
                  <v-text-field
                    v-model="editedItem.quantity"
                    value="0"
                    label="売上個数"
                    type="number"
                    min="0"
                    @click="editedItem.quantity = ''"
                  ></v-text-field>
                </v-flex>

                <v-flex xs5 sm5>
                  <v-text-field
                    v-model="editedItem.presentQuantity"
                    value="0"
                    label="プレゼント"
                    type="number"
                    min="0"
                    @click="editedItem.presentQuantity = ''"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
            </v-container>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">
                <v-icon dark>arrow_back</v-icon>{{ $t('back-btn') }}
              </v-btn>
              <v-btn color="blue darken-1" flat @click="editReportDetail()">
                <v-icon dark>save</v-icon>修正
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-dialog>

      <v-layout row wrap style="margin-top: 30px;">
        <v-flex xs12 sm12>
          <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-admin-menu' }">
            <v-icon color="black" left>home</v-icon>{{ $t('home-btn') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import moment from 'moment-timezone'
import ServerApiCallService from '@/services/ServerApiCallService.js'
import axios from 'axios'

export default {
  created() {
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)

    if (!this.salesReportDate) {
      this.$store.commit('SET_SALES_REPORT_DATE', moment().format('YYYY/MM/DD'))
    }

    //売上報告データの取得
    this.getSalesReport()
    //売上報告データ存在チェック
    this.existSalesReport()
  },
  computed: {
    salesReportDate: {
      get() {
        return this.$store.state.adminSession.salesReportDate
      },
      set(value) {
        this.$store.commit('SET_SALES_REPORT_DATE', value)
      }      
    },
    filteredStores() {
      if (!this.selectedBrand || !this.selectedBrand.brandId) {
        return this.stores
      }

      return this.stores.filter(store => store.brandId === this.selectedBrand.brandId)
    },
    displayGrandSumTotal() {
      const total = this.filteredStores.reduce((sum, store) => {
        return sum + this.toNumber(store.sumTotal)
      }, 0)

      return total.toLocaleString()
    },
  },
  methods: {
    getSalesReport() {
      console.log('getSalesReport')

      let request = {
        salesReportDate: this.salesReportDate.replace(/\//g, ''),
      }

      ServerApiCallService.getSalesReport(request)
        .then((response) => {
          this.suppliers = response.data.suppliers
          this.brands = response.data.brands          

          this.stores = response.data.stores

          console.log(response.data.stores);
          
          this.stores.forEach((item) => {
            if (item.createdAt) {
              item.createdAt = moment(item.createdAt).format('MM/DD HH:mm')
            }
          })
        })
        .catch((error) => {
          console.log('There was an error:', error.response)
        })
    },
    changeSalesReportDate() {
      this.salesReportDate = this.reportDatePicker.replace(/-/g, '/')
      //売上報告データの取得
      this.getSalesReport()
      //売上報告データ存在チェック
      this.existSalesReport()
    },
    forwardReportConfirmDetail(item) {
      console.log('forwardReportConfirmDetail')

      let thisObj = this

      // salesReportIdが「0」の場合、新規登録画面に遷移
      if (item.salesReportId === 0) {

        // add kium 20231213
        sessionStorage.setItem("selectedStore", JSON.stringify(item))

        this.$router.push({
          name: 'admin/report-regist',
          params: {
            selectedStore: {
              storeCode: item.storeCode,
              storeName: item.storeName,
            },
          },
        })
        return
      }

      this.selectedStoreReport = item

      let request = {
        salesReportId: item.salesReportId,
      }

      ServerApiCallService.getSalesReportDetail(request)
        .then((response) => {
          this.salesReportDetail = response.data.salesReportDetails

          this.sumTotal = 0

          this.salesReportDetail.forEach(function (row) {
            thisObj.sumTotal += row.unitPrice * row.quantity
          })

          this.sumTotal = Number(this.sumTotal).toLocaleString()

          this.salesUsers = []
          response.data.users.forEach(function (row) {
            var userList = {}
            if (!row.firstName) {
              userList = {
                userId: row.userId,
                userName: row.userId + ' ' + row.lastName,
              }
            } else {
              userList = {
                userId: row.userId,
                userName: row.userId + ' ' + row.lastName + ' ' + row.firstName,
              }
            }
            thisObj.salesUsers.push(userList)
          })

          this.workedUsers = []
          response.data.workedUsers.forEach(function (row) {
            thisObj.workedUsers.push(row.userId)
          })

          if (thisObj.salesReportDetail.length > 0) {
            this.remarks = thisObj.salesReportDetail[0].comments
          }
        })
        .catch((error) => {
          console.log('There was an error:', error)
        })

      this.dialog = true
    },
    editDetail(item) {
      console.log('editDetail')

      this.editedItem = item
      this.updateDialog = true
    },
    close() {
      this.updateDialog = false
    },
    editReportDetail() {
      console.log('editReportDetail')

      let thisObj = this

      this.sumTotal = 0
      this.selectedAddItem = []

      this.salesReportDetail.forEach(function (row) {
        if (row.itemCode == thisObj.editedItem.itemCode) {
          row.quantity = Number(thisObj.editedItem.quantity)
          row.presentQuantity = Number(thisObj.editedItem.presentQuantity)
          row.referenceStock = Number(thisObj.editedItem.referenceStock)
        }
        thisObj.sumTotal = thisObj.sumTotal + row.unitPrice * row.quantity
      })
      this.sumTotal = Number(this.sumTotal).toLocaleString()
      this.updateDialog = false
    },
    closeDetailDialog() {
      this.dialog = false
      this.updateDialog = false
      this.addDialog = false
    },
    updateSalesReport() {
      console.log('updateSalesReport')

      var selectedSalesUsers = []
      for (let i = 0; i < this.workedUsers.length; i++) {
        if (this.workedUsers[i].userId) {
          selectedSalesUsers.push(this.workedUsers[i].userId)
        } else {
          selectedSalesUsers.push(this.workedUsers[i])
        }
      }

      let request = {
        salesReportId: this.selectedStoreReport.salesReportId,
        salesReportDetail: this.salesReportDetail,
        workedUsers: selectedSalesUsers,
        sumTotal: Number(this.sumTotal.replace(/,/g, '')),
        comments: this.remarks
      }

      ServerApiCallService.updateSalesReport(request)
        .then((response) => {
          this.dialog = false
          this.getSalesReport()
        })
        .catch((error) => {
          console.log('There was an error:', error)
        })
    },
    functionEvents(date) {
      var day = date.replace(/-/g, '')
      if (this.existsSalesReportData.includes(day)) return true
    },
    existSalesReport() {
      console.log('existSalesReport')

      var requestSalesReportDate = ''

      if (!this.salesReportDateForPicker) {
        requestSalesReportDate = moment().format('YYYYMMDD')
      } else {
        requestSalesReportDate = moment(this.salesReportDateForPicker).format(
          'YYYYMMDD'
        )
      }

      let request = {
        salesReportDate: requestSalesReportDate,
      }

      ServerApiCallService.existSalesReportByAdmin(request)
        .then((response) => {
          this.existsSalesReportData = response.data.existSalesReports
        })
        .catch((error) => {
          console.log("existSalesReport err");
        })
    },
    deleteDialog(item) {
      console.log('deleteDialog')
      this.selectedSalesReport = item
      this.dispDeleteDialog = true
    },
    deleteSalesReport() {
      console.log('deleteSalesReport')

      let request = {
        salesReportId: this.selectedSalesReport.salesReportId,
      }

      ServerApiCallService.deleteSalesReport(request)
        .then((response) => {
          this.dispDeleteDialog = false
          //売上報告データの取得
          this.getSalesReport()
        })
        .catch((error) => {
          console.log('There was an error:', error.response)
          this.getSalesReport()
        })
    },
    addItem() {
      // this.$refs.addReportItem.focus()

      let thisObj = this
      this.addDialog = true

      let request = {
        storeCode: this.selectedStoreReport.storeCode,
      }

      ServerApiCallService.getStoreItems(request)
        .then((response) => {
          this.storeItems = response.data.storeItems

          // 등록한 상품 이외의 점포의 상품을 표시
          // 점포에 1나의 상품만 있고, 그 상품이 등록된 경우 추가할 상품이 안보인다
          for (let i = 0; i < this.storeItems.length; i++) {
            // 報告された商品は商品リストから削除
            thisObj.salesReportDetail.forEach((reportDetail) => {
              
              if (reportDetail.itemCode == this.storeItems[i].itemCode) {
                this.storeItems.splice(
                  this.storeItems.indexOf(this.storeItems[i]),
                  1
                )

              //   // i가 0인 경우는 감소를 하지 않게 수정                
                if (i > 0) i--;
              }
            })

            // 検索用の商品名を設定
            this.storeItems[i].dispItemName =
              this.storeItems[i].janCode +
              '  ' +
              this.storeItems[i].itemName
          }
        })
        .catch((error) => {
          console.log('There was an error:', error)
        })
    },
    onChangeReportItem() {
      console.log('onChangeReportItem')
      this.selectedAddItem = this.addReportItem
    },
    closeAddItem() {
      this.addReportItem = []
      this.selectedAddItem = []
      this.addDialog = false
    },
    addSalesReportDetail() {
      console.log('addSalesReportDetail')

      let thisObj = this
      this.selectedAddItem.salesReportId = this.selectedStoreReport.salesReportId

      this.sumTotal = 0
      this.salesReportDetail.push(this.selectedAddItem)
      this.salesReportDetail.forEach(function (row) {
        thisObj.sumTotal += Number(row.unitPrice) * Number(row.quantity)
      })

      this.sumTotal = Number(this.sumTotal).toLocaleString()
      this.closeAddItem()
    },
    downloadCsv() {
      
      if (this.downloadLoading) return   // 다운로드 중이면 무시
      if (!this.validateDownloadPeriod()) return   // 추가

      this.downloadLoading = true

      let request = {
        brandId: this.selectedBrandForDownload,
        startDate: this.startDate.replace(/-/g, ''),
        endDate: this.endDate.replace(/-/g, ''),
      }

      console.log('request body' + JSON.stringify(request))

      axios
        .create({
          baseURL: ServerApiCallService.getServerUrl(),
          withCredentials: false, // This is the default
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json;charset=utf-8',
            accessToken: window.localStorage.getItem('accessToken'),
          },
        })
        .post('/admin/salesReport-download', request, {
          responseType: 'blob',
        })
        .then(({ data }) => {

            const blob = new Blob([data], { type: 'text/csv' })
            const url = window.URL.createObjectURL(blob)

            const link = document.createElement('a')

            link.href = url
            link.download =
                '売上報告_' +
                this.startDate.replace(/-/g, '') +
                '_' +
                this.endDate.replace(/-/g, '') +
                '.csv'

            document.body.appendChild(link)

            try {
                link.click()
            } finally {
                link.remove()

                // 브라우저가 다운로드 처리를 시작할 시간을 확보한 후 해제
                setTimeout(() => {
                    window.URL.revokeObjectURL(url)
                }, 1000)
            }
        })
        .catch((error) => {
          console.log('There was an error:', error)

          if (error.response && error.response.status === 409) {
              alert('現在CSVをダウンロード中です。完了するまでお待ちください。')
          } else if (error.response && error.response.status === 503) {
              alert('サーバーが混み合っています。しばらくしてから再度お試しください。')
          } else {
              alert('CSVのダウンロードに失敗しました')
          }

        })

        .finally(() => {
          this.downloadLoading = false
        })
    },
    validateDownloadPeriod() {
      const start = moment(this.startDate, 'YYYY-MM-DD')
      const end = moment(this.endDate, 'YYYY-MM-DD')

      if (!start.isValid() || !end.isValid()) {
        alert('正しい日付を指定してください')
        return false
      }

      if (end.isBefore(start)) {
        alert('終了日は開始日以降の日付を指定してください')
        return false
      }

      // 시작일 포함 최대 1년
      if (end.isSameOrAfter(start.clone().add(12, 'months'))) {
          alert('ダウンロード期間は1年以内で指定してください')
          return false
      }

      return true
    },
    toNumber(value) {
      if (value === null || value === undefined || value === '') {
        return 0
      }

      if (typeof value === 'number') {
        return value
      }

      return Number(String(value).replace(/,/g, '')) || 0
    },
    
  },
  data() {
    return {
      downloadLoading: false,
      selectedAddItem: [],
      addReportItem: '',
      storeItems: [],
      addDialog: false,
      selectedSalesReport: [],
      dispDeleteDialog: false,
      existsSalesReportData: [],
      editedItem: [],
      updateDialog: false,
      // salesReportDate: '',
      reportDatePicker: '',
      menu: false,
      menu2: false,
      menu3: false,
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      dialog: false,
      selectedSupplier: {},
      selectedBrand: {},
      selectedSupplierForDownload: '',
      selectedBrandForDownload: '',
      suppliers: [],
      brands: [],
      headers: [
        {
          text: '店舗名',
          align: 'left',
          value: 'storeName',
          width: '60%',
          sortable: false,
          fixed: true,
        },
        {
          text: '報告者',
          align: 'center',
          value: 'createdUser',
          width: '20%',
          sortable: false,
          fixed: true,
        },
        {
          text: '報告時間',
          align: 'center',
          value: 'createdAt',
          width: '20%',
          sortable: false,
          fixed: true,
        },
        {
          text: '',
          align: 'left',
          sortable: false,
          value: 'delete',
          width: '20px',
        },
      ],
      stores: [],
      salesReportConfirmHeader: [
        {
          text: '商品名',
          align: 'left',
          value: 'itemName',
          sortable: false,
          fixed: false,
        },
        {
          text: '売上個数',
          align: 'right',
          sortable: false,
          value: 'orderLimit',
          fixed: true,
        },
        {
          text: 'プレゼント',
          align: 'right',
          sortable: false,
          value: 'orderLimit',
          fixed: true,
        },
        {
          text: '売上金額',
          align: 'right',
          sortable: false,
          value: 'orderLimit',
          fixed: true,
        },
        {
          text: '参考在庫',
          align: 'right',
          sortable: false,
          value: 'orderLimit',
          fixed: true,
        },
      ],
      salesReportDetail: [],
      workedUsers: [],
      salesUsers: [],
      selectedStoreReport: [],
      remarks: '',
      sumTotal: 0      
    }
  },
}
</script>

<style>
.title-highlight {
  font-size: 20px;          /* 🔹 기본 타이틀보다 크게 */
  font-weight: bold;        /* 🔹 굵게 */
  color: #2c3e50;           /* 🔹 진한 남색 계열 */
  /*border-left: 5px solid #4C728A; /* 🔹 왼쪽에 포인트 라인 */
  padding-left: 10px;       /* 🔹 라인과 글자 사이 간격 */
  margin-bottom: 10px;      /* 🔹 아래 여백 */
}
.hoge {
  width: 200px;
}
.column-input {
  width: 35px !important;
  height: 30px;
  text-align: right;
  border: 1px solid #c7c7c7;
  padding: 0 4px;
}
.active-class-name {
  background-color: #d5ffc4;
}
.brand-select-wrapper {
  width: 100%;
}
.brand-select-note {
  font-size: 12px;
  color: #666;
  line-height: 1.4;
  margin-top: -6px;
  padding-left: 2px;
}
</style>
